
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src994476363/src/vl-app/pages/clinician/assessments.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { useQuery } from '@tanstack/react-query';
import dynamic from 'next/dynamic';
import { getAssessmentSurvey } from '@actions';
import { useInitialisedStore } from '@hooks/useInitialisedStore';
import Footer from '@components/Layouts/Footer/Footer';
import { css } from '@emotion/react';
import Header from '@components/Layouts/Header/Header';

const Assessment = dynamic(() => import('@components/Clinicians/Assessment'), {
  ssr: false
});
const BackButton = dynamic(() => import('@components/UI/BackButton/BackButton'));

export const Assessments = () => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const dispatch = useDispatch();
  const { surveyjs_id } = router.query;
  const initialised = useInitialisedStore();

  const { isLoading, data: surveyRes } = useQuery({
    queryKey: ['getAssessmentSurvey', surveyjs_id],
    queryFn: async () => {
      const res = await dispatch(getAssessmentSurvey({ surveyjs_id: Number(surveyjs_id) }));
      return res.user_surveyjs[0];
    },

    enabled: !!surveyjs_id
  });

  if (!initialised) {
    return <p>{t('Initialising ...')}</p>;
  }

  return (
    <>
      <Header pageType="clinician" pageTitle="Assessments" />
      {surveyRes?.surveyjs_def_id && (
        <div
          className="section-layout"
          css={css`
            margin: 3em 0;
            display: flex;
            flex-direction: column;
            gap: 2em;
          `}
        >
          <BackButton text="Back" arrow onClick={() => router.back()} data-testid="back-button" />
          <Assessment isLoadingSurveyRes={isLoading} pageType="clinician" surveyRes={surveyRes} />
        </div>
      )}
      <Footer />
    </>
  );
};
export default Assessments;
export const Route = createFileRoute('/clinician/assessments')({ component: Assessments });
